// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> novo-stockbridge
// Generated: 2026-10-01T17:22:54.496Z
// Counts: 5 design, 99 content, 24 slot group, 3 collection binding, 10 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  },
  "design._site.color.linkVisited": {
    "cssVariable": "--vibe-color-link-visited",
    "overrideType": "VALUE",
    "value": "#00306b ",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 28px;\"><strong>Where Home Feels Effortless.</strong></span></h2><h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Stockbridge, your lifestyle thrives amid a vibrant community. Unwind at nearby Reynolds Nature Preserve, stay active with<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/featuring/fitness-center-apartments-georgia\"> Fitness Connection</a>, or enjoy the thrill of Spivey Splash Water Park. With spacious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom floor plans</a>, convenience and comfort are within reach. See what's around our community today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "Welcome to NOVO Stockbridge",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019df43f-b0f6-728f-aa17-c181d99623a5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience thoughtfully designed amenities that make it easy to relax, recharge, stay active, and connect with neighbors. From our resort-style pool to inviting outdoor spaces and modern fitness center, every detail is designed to elevate everyday living.</p><p> Choose from thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one to three-bedroom floor plans</a>, paired with luxurious amenities like a resort-inspired pool, state-of-the-art fitness center, and outdoor kitchen. Unwind in style—each apartment features designer finishes and chef-inspired kitchens, perfect for modern living. </p><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">See our gallery</a>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>We Can't Wait To Meet You!</strong></span></p><p>We'd love to show you around. Contact our team today to schedule your personal tour and discover everything NOVO Stockbridge has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Fit</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.description": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything You Need, Right Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-chatbot.position_side": {
    "overrideType": "VALUE",
    "customValue": "right",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe-2.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe-2.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Stockbridge, where style meets comfort, you’ll find thoughtfully designed floor plans to suit your lifestyle.</p><p>Explore spacious one, two, and three-bedroom apartment homes thoughtfully designed to complement your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>You'll Love It Here!</strong></span></p><p>Explore the spaces that make NOVO Stockbridge feel welcoming, comfortable, and distinctly home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-near-30281::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Stockbridge, we offer<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/pet-policy\"> dog-friendly apartments</a> near the 30281 area, ensuring both you and your furry companion find the perfect place to call home. Our community is designed with both comfort and convenience in mind, featuring <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">modern amenitie</a>s such as outdoor fire pits, stainless steel appliances, and more.</p><p>Your pet will love exploring our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">welcoming grounds</a> while you enjoy the luxury of our spacious units, which come equipped with movable kitchen islands and garden tubs. In addition to being pet-friendly, NOVO Stockbridge offers additional conveniences such as garages and storage closets. Nestled in the vibrant area of Stockbridge, GA, our community provides you with easy access to local pet-friendly parks and more. Come see why we are the ideal choice for you and your four-legged friend!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/fitness-center-apartments-georgia::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience modern living at NOVO Stockbridge, where our state-of-the-art fitness center caters to all your workout needs in the heart of Georgia. Our apartments provide everything you need for a well-rounded lifestyle, from convenient in-unit <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">amenities</a> like stainless steel appliances and movable kitchen islands to community features such as outdoor fire pits.</p><p>At NOVO Stockbridge, you’re not just choosing an apartment; you’re selecting a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">lifestyle complete </a>with unparalleled fitness solutions. After a fulfilling workout, unwind with a soak in our luxurious garden tubs or explore the vibrant Stockbridge neighborhood. Our community also offers practical solutions like garages and storage closets, ensuring your needs are always met. Located in Clayton County, our property provides a perfect balance of luxury and convenience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/garden-tubs-stockbridge-apartments::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Stockbridge, indulge in the soothing luxury of having your own garden tub right in the comfort of your apartment. Our Stockbridge apartments are <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">designed to elevate your living experience </a>with a blend of elegance and practicality. Each unit is equipped with <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">modern amenities</a> such as stainless steel appliances, movable kitchen islands, and more.</p><p>Beyond the tranquility of your garden tub, you'll find the community enriched with features like outdoor fire pits and convenient garages and storage closets. Located in the lively community of Stockbridge, GA, living at NOVO Stockbridge offers easy access to local dining, shopping, and entertainment options, ensuring you’re never far from excitement. Experience unparalleled comfort and modern design, right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-washer-dryer-apartments-stockbridge::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the convenience and style of apartments with in-unit washer dryers at NOVO Stockbridge, located in the vibrant community of Stockbridge, GA. Here, you can enjoy a modern and hassle-free lifestyle with access to a suite of <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">premium amenities</a> like movable kitchen islands, stainless steel appliances, and outdoor fire pits. Our spacious units are designed to cater to your every need.</p><p>NOVO Stockbridge not only offers the comfort of having a washer and dryer in your own apartment but also provides garage and storage options for additional convenience. You’ll love the luxury of our garden tubs, perfect for unwinding after a long day. Experience the perfect blend of comfort and practicality in Clayton County's thriving community. Explore all that NOVO Stockbridge has to offer today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pools-clayton-county::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the epitome of luxury apartment living in Clayton County at NOVO Stockbridge, where you'll find sophisticated residences complete with exclusive pool access. Our community is designed to provide residents with a premium lifestyle, including <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">amenities </a>like outdoor fire pits, stainless steel appliances, and movable kitchen islands, perfect for entertaining and relaxing.</p><p>Relax in the spacious surroundings of NOVO Stockbridge, where luxury extends beyond just our beautiful pools. Our apartments offer features such as garden tubs for a serene bathing experience, as well as garages and storage closets to accommodate your lifestyle needs. Located in vibrant Stockbridge, GA, our community provides easy access to local dining and shopping options, ensuring you're never far from your next adventure. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/contact\">Come discover upscale living with us today!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/stockbridge-rentals-near-village-park-ellenwood::hyperlocalpagecopy.text": {
    "overrideType": "VALUE",
    "customValue": "<p>For those seeking Stockbridge rentals close to Village Park Ellenwood, NOVO Stockbridge is an ideal option. Our community offers <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/gallery\">modern living</a> in proximity to the scenic landscapes and amenities of Village Park, perfect for those who appreciate nature and outdoor activities.</p><p>The apartments at NOVO Stockbridge <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">feature contemporary designs</a>, including stainless steel appliances and movable kitchen islands, enhancing daily life. Residents enjoy using outdoor fire pits, and benefit from available garages and storage closets. Situated conveniently near Village Park Ellenwood, our rentals provide easy access to leisurely hikes and recreational activities, making NOVO Stockbridge a top choice for comfortable, connected living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Stockbridge, elevate your lifestyle with our thoughtfully designed one, two, and three-bedroom apartments. Enjoy <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">luxurious amenities</a> like a resort-inspired pool, state-of-the-art fitness center, and vibrant community spaces. Use our interactive community map to find your perfect home in Stockbridge, GA—where comfort meets convenience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>Everything Within Reach</strong></span></p><p>Enjoy convenient access to shopping, dining, parks, entertainment, and everyday essentials while coming home to a peaceful community you'll love.</p><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/schedule-a-tour\">Schedule a tour!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>We Love Pets!</strong></span></p><p>At NOVO Stockbridge, your furry friends are part of the family! Nestled in scenic Stockbridge, GA, our pet-friendly community embraces up to two pets. With a spacious setting and easy access to nearby parks, you and your pets can enjoy a vibrant lifestyle, tailored with your comfort in mind.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs welcome. Maximum of 2 pets per unit. Please <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/contact\">contact leasing office </a>for more information.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to NOVO Stockbridge, where comfort meets style in the heart of Stockbridge, GA! </p><p>At NOVO Stockbridge, you'll discover a community designed for the way you live today. Spacious apartment homes, modern finishes, inviting community spaces, and everyday conveniences come together to create a place you'll truly enjoy coming home to.</p><p>Inside your home, contemporary finishes including granite countertops, stainless steel appliances, shaker-style cabinetry, and wood-style flooring create a clean, modern space that's both stylish and functional.</p><p>Spend sunny afternoons by the resort-style pool, gather with friends around the outdoor fire pit, stay active in the fitness center, or enjoy time outdoors with your pup at the bark park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.tab_community_label": {
    "overrideType": "VALUE",
    "customValue": "Spaces Designed Around You",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.tab_interior_label": {
    "overrideType": "VALUE",
    "customValue": "Thoughtfully Designed Interiors",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Stockbridge, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Enhance your living experience by accessing our resident portal, where you can easily pay rent, schedule maintenance, and stay connected to your community. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/schedule-a-tour\">Join us today!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At NOVO Stockbridge, our thoughtfully designed<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\"> one, two, and three-bedroom floor plans</a> offer the perfect blend of comfort and style. Experience the vibrant community atmosphere in Stockbridge, GA, and see what our residents love about calling NOVO home. Schedule a tour today to envision your next chapter!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.tour.source": {
    "overrideType": "VALUE",
    "customValue": "entrata",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at the spaces that could soon be yours. Explore our apartment homes virtually and imagine yourself enjoying life at NOVO Stockbridge before you even visit.</p><p>Nestled in vibrant Stockbridge, GA, our community blends modern comforts with stylish designs and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">luxury amenities.</a> Experience your future home by taking a virtual tour today, and envision the perfect lifestyle that awaits you!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019f928f-f1c1-74d7-8abb-bc87df8881ad.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fun-filled pool party with diverse friends enjoying colorful floats together."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-160e-778f-9263-d3d9a176bb7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment complex with a white clubhouse and a large apartment building in the background."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d3-40dc-74de-9b0a-3052ea901385.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fully furnished bedroom with a queen-size bed, dresser, and a chair."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d3-7e30-71e8-a419-f83123c18cad.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A modern bedroom with a queen-size bed, a nightstand, a ceiling fan, and a chair."
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-005b-717d-97bf-e5e87d7c9ec3.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-a89f-761c-9aeb-19f582f0858d.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d3-eec2-703a-b27a-56884ccb9f0f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury swimming pool with cabanas and lounge chairs at a multifamily property."
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019f9292-1aa1-761d-abcd-599ac9e78ca6.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group practicing yoga outdoors in city park with modern buildings. Fitness and wellness lifestyle."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": 9,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019f9294-a045-7351-ae48-69a111c353a1.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cheerful group of friends enjoys a celebration with cake on a sunny rooftop."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[22].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[22].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019f9290-f297-71e0-81c3-efcbe07c4591.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A diverse group of adults practicing yoga outdoors in a vibrant urban setting."
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019f9296-4ccc-732a-930d-b0b808d17248.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier sit together on a shelf by a window, showcasing pet companionship."
      }
    }
  },
  "preferredemployerprogram.benefit_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Preferred employees receive 3% off monthly rent  — subject to a qualifying credit check."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Reduced Monthly Rent"
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d3-6160-7240-b509-5d4d8ff691ce.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and subway tile backsplash."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_51bfde6a-ba5c-4f32-8a2a-99f8e94b011b"
    ],
    "orderedIds": [
      "custom_44ec92d0-ef11-4c75-9811-9a5dea21b048",
      "custom_98bc84f6-2bd4-4937-b9b0-8201a64c55b4",
      "custom_536b6893-ae01-44de-aef6-03bed51afc05",
      "custom_a8ce1700-242b-49a0-826f-468504460593",
      "custom_599e320a-859d-4afe-80c1-d34c4f1f218c",
      "custom_fd357b08-572a-4bf5-bf2b-1a5fb25ee259",
      "custom_da75230a-8b53-4c4f-aeec-e916071ab8ad",
      "custom_fece29a5-c514-4d22-ac95-99246ec14c88",
      "custom_24b25967-0e77-444d-83f1-f9c88828c5db",
      "custom_a3d9f779-1132-49d7-a272-a17506f321f2",
      "custom_abe3250c-2b82-4ce1-834e-c32c9347af30",
      "custom_be471b63-0647-45f3-9ac9-db1f46c29802",
      "custom_51bfde6a-ba5c-4f32-8a2a-99f8e94b011b",
      "custom_b2a098a2-a94a-4edd-a48a-87dbe25622dc",
      "custom_822e5e4f-cac5-4422-8965-2ce39ee2d53c",
      "custom_33a5c149-d332-4471-9dba-3ceb4910cafb",
      "custom_96ff7115-1eaa-4e86-a3fc-7a056d09acbd",
      "custom_adbf7a7a-2eca-4ff5-86c3-84aa8d16b366",
      "custom_4ac4f25c-5475-4252-a3fc-1db084b09a50",
      "custom_068b2f8a-7426-4f75-a289-a7026f26b175",
      "custom_fead3909-5421-4cb2-b446-fc73d85c687f",
      "custom_dc317b19-5eaf-47df-a0e7-2dbc868220af",
      "custom_a3610382-21bf-4d9d-86fa-eda5886876b0",
      "custom_db1d33f4-c498-45cf-9ec9-e9c247282d95",
      "custom_02ee9387-015e-4d5e-9483-ad82e451e1c6",
      "custom_048503c3-297d-403a-a0a6-01bcb786df77",
      "custom_3a4cabf8-fa9e-44dc-bcc1-ca3ce75caa18",
      "custom_de9d90fc-8c11-46e4-b2f6-0900afd2d914",
      "custom_414b41a7-e618-4e80-b0c2-19b9e233161c",
      "custom_fe5c0a03-7a14-49e0-b00c-3e08007c27bb",
      "custom_add07272-9e0d-4072-b39a-df8fb4b5b28f",
      "custom_201d40c4-15f3-4469-a71d-fd866149c857",
      "custom_468dfaba-6d3c-4ce4-985f-93dc403f45c8",
      "custom_88408e14-e6ab-40b6-85ed-b039cff35a81",
      "custom_a2fe2448-a528-43c2-8e86-7c8e0352e82a",
      "custom_affe4c37-9688-49dc-a9bb-345b25c281f9",
      "custom_6a8b8d6b-43be-45b0-b5df-a220f8ecef6d",
      "custom_aac00a56-72d8-441d-af4a-db5532d91b0f",
      "custom_cbc9cb7b-a78e-43c8-b5b1-7ac3a9ff45c9",
      "custom_9b17612b-f45b-4db2-b72c-991f64c40bec",
      "custom_e318af51-3873-4af8-ae96-641d23b3d9b8",
      "custom_1c8c54f5-be20-453c-b111-355f937566da",
      "custom_c6a32c22-f209-412c-b3fc-0af739746475",
      "custom_a8269ccd-795c-46fc-a1f7-695260fe5a83",
      "custom_3151ba5a-b57f-4ed0-bb2c-537a17179222",
      "custom_e0bd1901-779f-4783-b5d7-0666ddba1401",
      "custom_f578769a-6028-4dfc-a45b-414dae063cc0",
      "custom_5a2748fd-5040-4858-b232-b4660251cabb",
      "custom_3663a8d5-7f83-4df6-92c6-803d820a7943",
      "custom_7bb0bd6f-7a3a-4d88-8954-f87a4e9cef94",
      "custom_d5f719e2-ec50-4c65-b9c7-0579752b3174",
      "custom_5b42d6af-4e9f-4521-b00a-d411ce9f9b22",
      "custom_1bf6d9b8-7576-4186-a771-baffa90fc0c9",
      "custom_71e39687-b3d5-41ed-99a1-dcdb46710257",
      "custom_74f5e5d4-49e7-45c4-b27b-f5e464fe7dbd",
      "custom_13b28fe0-f3ea-4438-93ac-1c032bc07b83",
      "custom_573d43bd-31b4-4b36-8e03-1c69eea9314d",
      "custom_f3502ffa-8e8a-40af-956b-26ef52c6ee04",
      "custom_97b26852-5f09-44ea-ba6b-0282daaece30",
      "custom_7903fb7c-9d90-4a86-a388-b9da95f43a27",
      "custom_65d5015b-fd4a-4a0b-818a-1f6512055242",
      "custom_44128188-302a-49e2-a870-f73a8aacd4ee"
    ],
    "hiddenIndices": [
      0
    ],
    "ordering": [
      4,
      1,
      2,
      3,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      0,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 8,
      "visible": false
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  }
};
